export default "__VITE_ASSET__DIRNPRVv__"